import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DocState {
  documents: DocDataTypes[];
}

const initialState: DocState = {
  documents: [],
};

export const documentSlice = createSlice({
  name: "document",
  initialState,
  reducers: {
    setDocs: (state, { payload }: PayloadAction<DocState["documents"]>) => {
      state.documents = payload;
    },
    clearDocs: (state) => {
      state.documents = [];
    },
  },
});

export const { setDocs, clearDocs } = documentSlice.actions;
